<template>
  <div class="rs-status-badge">
    <span :class="`${variant} ${size}`" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

const variants: Array<string> = [
  'unavailable',
  'deactivated',
  'activated',

  'active',
  'archived',
  'deleted',
];

const sizes = ['sm', 'md'];

export default defineComponent({
  name: 'RsStatusBadge',

  props: {
    variant: {
      type: String,
      required: true,
      validator: (prop: string) => (variants.includes(prop)),
    },

    size: {
      type: String,
      validator: (prop: string) => (sizes.includes(prop)),
      default: 'sm',
    },
  },
});
</script>

<style lang="scss" scoped>

@import '@/styles/_variables.scss';

.rs-status-badge {
  left: 0;
  text-align: center;
  justify-content: center;
  font-weight: 700;

  & .fa-info-circle{
    margin-top: 0.5rem;
    color: $info;
    position: relative;
  }

  > span {
    &:before {
      content: "";
      display: block;
      border-radius: 50%;
      flex-shrink: 0;
    }

    &.sm:before {
      width: 8px;
      height: 8px;
    }

    &.md:before {
      width: 12px;
      height: 12px;
    }

    &:hover {
      cursor: pointer;
    }

    &.activated:before {
      background: $success;
    }
    &.deactivated:before {
      background: $warning;
    }
    &.unavailable:before {
      background: $error;
    }

    &.active:before {
      background: $success;
    }
    &.archived:before {
      background: $medium-grey;
    }
    &.deleted:before {
      background: $error;
    }
  }
}
</style>
